import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Loading from 'ui/pages/applicant/Loading'
import { getMed, getVcUrl } from 'app/personal/fetch'
import SystemError, { ZoomConnectionError } from 'ui/pages/med/SystemError'
import ReservationVCNotPrepared from 'ui/pages/applicant/ReservationVCNotPrepared'
import type { MedicalInstitutionProps } from 'types/applicant'
import type { CallMethodNames } from 'types/common'
import { ApiErrorWithMessage, NotFoundError } from '../client'

const pollingInterval = 10 * 1000
const pollingMaxTime = 5 * 60 * 1000

const Meeting: React.FC = () => {
  const { institution_access_key, access_key, app } = useParams<
    'institution_access_key' | 'access_key' | 'app'
  >() as {
    institution_access_key: string
    access_key: string
    app: string
  }

  const [med, setMed] = useState<MedicalInstitutionProps | undefined>() //NOTE: 医療機関データ

  const [systemError, setSystemError] = useState<boolean>(false)
  const [notFound, setNotFound] = useState<boolean>(false)
  const [zoomConnectionErrorMode, setZoomConnectionErrorMode] = useState<
    'token' | 'temporary' | null
  >(null)

  const meetingStartHandler = (app: CallMethodNames) => {
    getVcUrl(app)(access_key)
      .then((data) => {
        setZoomConnectionErrorMode(null)
        window.location.href = data.url
      })
      .catch((e) => {
        if (e instanceof NotFoundError) {
          setZoomConnectionErrorMode(null)
          setNotFound(true)
        } else if (
          app === 'video_zoom' &&
          e instanceof ApiErrorWithMessage &&
          e.has({
            type: 'server_error',
            key: 'token',
            value: 'valid',
          })
        ) {
          setZoomConnectionErrorMode('token')
        } else if (app === 'video_zoom' && e.response.status === 503) {
          // Zoomのサーバーの名前解決ができないなど一時的なサーバーエラー
          setZoomConnectionErrorMode('temporary')
        } else {
          // その他の予期しないエラー
          console.log(e)
          setZoomConnectionErrorMode(null)
          setSystemError(true)
        }
      })
  }

  const fetchMed = () => {
    getMed(institution_access_key)
      .then(setMed)
      .catch(() => setSystemError(true))
  }

  function meetingStart() {
    if (app === 'teams') {
      meetingStartHandler('video_teams')
    } else {
      meetingStartHandler('video_zoom')
    }
  }

  useEffect(() => {
    meetingStart()
    fetchMed()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // pollingIntervalごとにURLを取得し直し、画面を放置してもURLが取得できるようにする
  useEffect(() => {
    let timer: NodeJS.Timeout
    let pollingTime = 0

    if (zoomConnectionErrorMode) {
      timer = setInterval(() => {
        pollingTime += pollingInterval
        if (pollingTime > pollingMaxTime) {
          clearInterval(timer)
          return
        }
        meetingStart()
      }, pollingInterval)
    }
    return () => {
      clearInterval(timer)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zoomConnectionErrorMode])

  if (notFound) {
    return <ReservationVCNotPrepared med={med} />
  }

  if (zoomConnectionErrorMode) {
    return <ZoomConnectionError mode={zoomConnectionErrorMode} />
  }

  if (systemError) {
    return <SystemError type={'personal'} />
  }

  return <Loading />
}

export default Meeting
